<template>
  <Day day="24.12.2022">
    <div slot="page-content">
      <h1 class="headline mb-5 align-center px-5">Itt a napja</h1>

      <p class="px-5 py-5">
        Most, hogy már az 5 perces fájásokkal küzd Mari és hamarosan kisjézuska is 2022. alkalommal látja meg a napvilágot, itt az ideje, hogy NAGYON BOLDOG KARÁCSONYT kívánjak!<br />
        A fám már áll, a vérem pezseg, a szobát zöld illat lengi be és a kaja is lassan bekerül a tepsibe, de hiányzik még egy hozzávaló, egy jóravaló szexike, ki a lakást a seggével veszi be.
      </p>
      <p class="px-5 py-5">
        
      </p>
      <h3>A kárcsonyfám: </h3>
      <p class="px-5 py-5">
        <v-img
            style="margin: 0 auto"
            max-width="300"
            src="../../assets/fa.jpg"
        ></v-img>
      </p>

      
    </div>
  </Day>
</template>
  
  <script>
import Day from "@/views/days/Day.vue";

export default {
  name: "Day24",
  components: {
    Day,
  },
  data() {
    return {
      hover: false,
    };
  },
  mounted() {
    document.body.classList.add("pihi");
  },
  destroyed() {
    document.body.classList.remove("pihi");
  },
};
</script>
  

<style lang="scss">
.italic {
  font-style: italic;
}
p {
  font-size: 1.3em;
  line-height: 1.8;
}
.hover {
  filter: blur(5px);
  transition: filter 500ms ease-in-out;
  cursor: pointer;
  &:hover {
    filter: blur(0);
  }
}
</style>